// Standalone bundle for self-hosted video playback. Kept out of app.js because
// hls.js is heavy and only a few pages carry a video, so the bundle is pulled
// in globally but async. Two layers, both keyed off `video[data-video-hls]`:
//   * modules/cms/video-player — data layer: attaches the HLS source (hls.js),
//     sends the tracking beacons, enforces the pause/seek guards.
//   * modules/cms/video-plyr — UI layer: wraps the same <video> with Plyr and
//     the muted-autoplay overlay.
// The data layer runs first so hls.js and hlsInstance exist before Plyr skins.

import * as videoPlayer from './modules/cms/video-player';
import * as videoPlyr from './modules/cms/video-plyr';

function init() {
  videoPlayer.init();
  videoPlyr.init();
}

init();
document.addEventListener('DOMContentLoaded', init);
